import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import RoleShell, { money } from "@/roleapps/RoleShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function InstallerApp() {
  const [orders, setOrders] = useState(null);
  const [active, setActive] = useState(null);     // order_id
  const [inst, setInst] = useState(null);
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [msg, setMsg] = useState("");

  const load = useCallback(() => {
    axios.get(`${API}/orders`).then((r) => setOrders(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Load failed"));
  }, []);
  useEffect(load, [load]);

  const open = async (o) => {
    setActive(o.id); setErr(""); setMsg("");
    const { data } = await axios.get(`${API}/orders/${o.id}/installer`);
    setInst(data);
  };
  const toggle = async (item) => {
    if (inst.signoff) return;
    const { data } = await axios.patch(`${API}/orders/${active}/installer`, { item_id: item.id, done: !item.done });
    setInst((p) => ({ ...p, checklist: data.checklist }));
  };
  const signoff = async () => {
    setErr(""); setMsg("");
    try {
      const { data } = await axios.patch(`${API}/orders/${active}/installer`, { signoff_by: name.trim() || "Installer" });
      setInst((p) => ({ ...p, signoff: data.signoff }));
      setMsg("Installation signed off.");
    } catch (e) { setErr(typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "Sign-off failed"); }
  };

  const allDone = inst && inst.checklist.every((i) => i.done);

  return (
    <RoleShell mark="IN" title="Installer" subtitle="Installation tasks" testid="installer-app">
      {!active ? (
        <>
          <h1 className="ra-h1">Assigned installations</h1>
          <p className="ra-h1sub">Open an order to run the site checklist and sign off the installation.</p>
          {err && <div className="ra-msg err">{err}</div>}
          {!orders ? <div className="ra-empty">Loading…</div> : orders.length === 0 ? (
            <div className="ra-card ra-empty">No installation orders assigned yet.</div>
          ) : (
            <div className="ra-card">
              <table className="ra-table" data-testid="installer-orders">
                <thead><tr><th>Order</th><th>Status</th><th>Total</th><th></th></tr></thead>
                <tbody>
                  {orders.map((o) => (
                    <tr key={o.id}>
                      <td><b>{o.number}</b></td>
                      <td><span className="ra-badge">{o.status}</span></td>
                      <td>{money(o.total)}</td>
                      <td style={{ textAlign: "right" }}><button className="ra-btn" data-testid={`open-${o.id}`} onClick={() => open(o)}>Open →</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      ) : (
        <>
          <button className="ra-btn ghost" onClick={() => { setActive(null); setInst(null); load(); }} style={{ marginBottom: 16 }}>← All orders</button>
          {!inst ? <div className="ra-empty">Loading…</div> : (
            <div style={{ maxWidth: 620 }}>
              <h1 className="ra-h1">{inst.number}</h1>
              <p className="ra-h1sub">Site checklist · status {inst.status}</p>
              {err && <div className="ra-msg err">{err}</div>}
              {msg && <div className="ra-msg ok">{msg}</div>}
              <div data-testid="checklist">
                {inst.checklist.map((it) => (
                  <label key={it.id} className={`ra-check ${it.done ? "done" : ""}`} data-testid={`check-${it.id}`}>
                    <input type="checkbox" checked={it.done} disabled={!!inst.signoff} onChange={() => toggle(it)} />
                    <span className="lab">{it.label}</span>
                  </label>
                ))}
              </div>
              {inst.signoff ? (
                <div className="ra-msg ok" data-testid="signoff-done" style={{ marginTop: 14 }}>
                  Signed off by <b>{inst.signoff.by}</b> on {(inst.signoff.at || "").slice(0, 10)}.
                </div>
              ) : (
                <div className="ra-card" style={{ marginTop: 16 }}>
                  <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>Sign-off</div>
                  <div style={{ display: "flex", gap: 10 }}>
                    <input data-testid="signoff-name" placeholder="Installer name" value={name} onChange={(e) => setName(e.target.value)}
                      style={{ flex: 1, padding: "9px 11px", borderRadius: 9, border: "1px solid #d4d4d8", fontSize: 13 }} />
                    <button className="ra-btn" disabled={!allDone} data-testid="signoff-btn" onClick={signoff}>
                      {allDone ? "Sign off" : "Complete all items"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      )}
    </RoleShell>
  );
}
